/* eslint-disable */
import React from 'react'
import { Heading, ContentfulRichText, Body } from '@superhi/design'

import Hyperlink from '../Hyperlink'

import { Wrapper, Code } from './styles'
import slugify from 'slugify'

const NODE_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['nodeOverrides'] = {
  paragraph: (_, children) => <Body level="2">{children}</Body>,
  'heading-1': (_, children) => (
    <Heading id={createIdFromNode(children)} level="3" maxWidth={18} as={'h2'}>
      {children}
    </Heading>
  ),
  'heading-2': (_, children) => (
    <Heading id={createIdFromNode(children)} level="4" maxWidth={18} as={'h3'}>
      {children}
    </Heading>
  ),
  'heading-3': (_, children) => (
    <Heading id={createIdFromNode(children)} level="5" maxWidth={18} as={'h4'}>
      {children}
    </Heading>
  ),
  // these 3 heading sizes will be removed
  'heading-4': (_, children) => (
    <Heading level="5" maxWidth={18} as={'h5'}>
      {children}
    </Heading>
  ),
  'heading-5': (_, children) => (
    <Heading level="5" maxWidth={18} as={'h5'}>
      {children}
    </Heading>
  ),
  'heading-6': (_, children) => (
    <Heading level="5" maxWidth={18} as={'h5'}>
      {children}
    </Heading>
  ),
  hyperlink: (node, children) => <Hyperlink url={node.data.uri}>{children}</Hyperlink>,
}

function createIdFromNode(node: React.ReactNode) {
  return slugify(String(node).replace(/\//, ' '), {
    lower: true,
  })
}

const MARK_OVERRIDES: React.ComponentProps<typeof ContentfulRichText>['markOverrides'] = {
  code: (children) => <Code>{children}</Code>,
}

type Props = {
  children: string
}

const ContentfulRichTextBody: React.FC<React.PropsWithChildren<Props>> = ({ children }) => (
  <Wrapper>
    <ContentfulRichText nodeOverrides={NODE_OVERRIDES} markOverrides={MARK_OVERRIDES}>
      {children}
    </ContentfulRichText>
  </Wrapper>
)

export default ContentfulRichTextBody
